// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__QI7b2","Success":"Button__Success__2dHUt","Danger":"Button__Danger__2xnhN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 148
// module chunks = 3